import Alpine from 'alpinejs';

Alpine.data('animatedbackground', () => ({
    init() {
        new animatedBackground(this.$root);
    },
}));

const mobileMediaQuery = window.matchMedia('(max-width: 767px)');
const isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent) || (
    window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1
);

function shouldDisableHeroAnimation(element) {
    return element.closest('.hero') && (mobileMediaQuery.matches || isIOS);
}

class animatedBackground {
    constructor(element) {
        this.element = element;
        if (!element) return;

        if (shouldDisableHeroAnimation(element)) {
            this.pauseSvgAnimations();
            return;
        }

        this.blobList = [];
        this.classes = {
            blob: 'animated-background__blob',
        };

        this.setAllBlobs();
        this.toggleAnimation();

        window.addEventListener('scroll', () => requestAnimationFrame(() => {
            this.toggleAnimation();
        }));
    }

    pauseSvgAnimations() {
        this.element.querySelectorAll('svg').forEach((svg) => {
            if (typeof svg.pauseAnimations === 'function') {
                svg.pauseAnimations();
            }
        });
    }

    setAllBlobs() {
        Array.from(this.element.querySelectorAll(`.${this.classes.blob}`)).forEach(blobElement => {
            this.blobList.push(new Blob(blobElement));
        });

        return this.blobList;
    }

    getAllBlobs() {
        return this.blobList;
    }

    toggleAnimation() {
        this.getAllBlobs().forEach(blob => {
            blob.changeVisibility(this.isPartiallyInViewport());
        });
    }

    isInViewport() {
        let rect = this.element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= window.innerHeight &&
            rect.right <= window.innerWidth
        );
    }

    isPartiallyInViewport() {
        let rect = this.element.getBoundingClientRect();
        let windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        let windowWidth = (window.innerWidth || document.documentElement.clientWidth);
        let vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
        let horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);
        return (vertInView && horInView);
    }
}

class Blob {
    constructor(element) {
        if (!element) return;

        this.isVisible = false;
        this.status = 'stopped';
        this.element = element;
        this.blockWidth = this.element.parentNode.getBoundingClientRect().width;
        this.blockHeight = this.element.parentNode.getBoundingClientRect().height;
        let minWindowSide = Math.min(window.innerWidth, window.innerHeight);
        let minBlockSide = Math.min(this.blockWidth, this.blockHeight);
        let maxWindowSide = Math.max(window.innerWidth, window.innerHeight);
        let maxBlockSide = Math.max(this.blockWidth, this.blockHeight);
        this.maxSize = maxBlockSide / maxWindowSide * maxBlockSide / maxWindowSide + 2;
        this.minSize = minBlockSide / minWindowSide * minBlockSide / minWindowSide + 2;
        requestAnimationFrame(() => this.setNewStyles); // for immediate animation start
        this.duration = this.getRandom(3000, 4000);
    }

    animate() {
        if (this.status === 'animating') return;

        requestAnimationFrame(() => {this.setNewStyles()});
        // loop animating movement, so it looks like the blobs are floating
        this.interval = setInterval(() => {
            requestAnimationFrame(() => {this.setNewStyles()});
        }, this.duration);
        this.status = 'animating';
    }

    stop() {
        clearInterval(this.interval);
        this.status = 'stopped';
    }

    changeVisibility(visibility) {
        if (visibility === this.isVisible) return;
        this.isVisible = visibility;
        if (visibility) {
            this.animate();
        } else {
            this.stop();
        }
    }

    setNewStyles(element, blockWidth, blockHeight, minSize, maxSize, duration) {
        element = element || this.element;
        blockWidth = blockWidth || this.blockWidth;
        blockHeight = blockHeight || this.blockHeight;
        minSize = minSize || this.minSize;
        maxSize = maxSize || this.maxSize;
        duration = duration || this.duration;
        let moveFactor = .2;
        let scale = this.getRandom(minSize, maxSize) * 1.2;
        // let blur = parseFloat((scale / 0.03 - 115).toFixed(2));

        element.style.transform = `translate(${this.getRandom(-1 * moveFactor, moveFactor) * blockWidth}px, ${this.getRandom(-1 * moveFactor, moveFactor) * blockHeight}px) scale(${scale}) rotate(${this.getRandom(-180, 180)}deg)`;
        // element.style.filter = `blur(${blur}px)`;
        // element.style.opacity = this.getRandom(.6, 1);
        element.style.transitionDuration = `${duration}ms`;
    }

    getRandom(min, max) {
        min = min || 0;
        max = max || 1;
        return parseFloat((Math.random() * (max - min) + min).toFixed(2));
    }
}
